'use client';
import React from 'react';

class TasticErrorBoundary extends React.Component<
  { children: React.ReactNode; tasticType: string },
  { hasError: boolean }
> {
  constructor(props: { children: React.ReactNode; tasticType: string }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error(`Error in tastic ${this.props.tasticType}:`, error);
    console.error('Component stack:', errorInfo.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="rounded-lg border border-red-100 bg-red-50 p-6">
          <div className="flex flex-col items-center text-center">
            <h3 className="mb-2 text-lg font-semibold text-red-800">Oops! Something went wrong</h3>
            <p className="mb-4 text-sm text-red-600">
              We encountered an error loading this component. Please try refreshing the page.
            </p>
            <div className="flex gap-4">
              <button
                onClick={() => window.location.reload()}
                className="rounded bg-red-600 px-4 py-2 text-sm text-white hover:bg-red-700"
              >
                Reload Page
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default TasticErrorBoundary;
